import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

import logo_white_svg from "../../common/icons/svg/logo-white.svg";
import logo_svg from "../../common/icons/svg/logo.svg";
import logo_vector from "../../common/icons/svg/logo-vector.svg";
import left_arrow_empty from "../../common/icons/svg/left-arrow-empty.svg";
import right_arrow_empty from "../../common/icons/svg/right-arrow-empty.svg";
import workflow_illustration_svg from "../../common/icons/svg/workflow-illustration.svg";
import hippa_svg from "../../common/icons/svg/hippa.svg";
import connected_devices_svg from "../../common/icons/svg/connected-device.svg";
import accessible_svg from "../../common/icons/svg/accessible.svg";

import "./Login.scss";
import { login } from '../../helper/login-helper';
import { redirect } from '../../common/utils/RedirectionUtils';
import { LOGIN_CONST, PAGE_CONST } from '../../common/constant/page-constants';

import { clearAlarms, clearStore, hospitalDataAction, userDataAction } from '../../modules/actions/action';


function Login(props) {
    const CONTENT_LIST = [{
        heading: "Workflow Automation",
        body: `1. Lorem ipsum dolor sit amet,
            consectetur adipiscing elit. Quam mi tortor cursus
            tincidunt purus tortor cursus tincidunt purus.`,
        src: workflow_illustration_svg
    }, {
        heading: "HIPAA Compliant-Data Security and Privacy",
        body: `2. Lorem ipsum dolor sit amet, \
        consectetur adipiscing elit. Quam mi tortor cursus \
        tincidunt purus tortor cursus tincidunt purus.`,
        src: hippa_svg
    }, {
        heading: "Connected Medical Devices",
        body: `3. Lorem ipsum dolor sit amet, \
        consectetur adipiscing elit. Quam mi tortor cursus \
        tincidunt purus tortor cursus tincidunt purus.`,
        src: connected_devices_svg
    }, {
        heading: "Accessible from App and Web",
        body: `4. Lorem ipsum dolor sit amet, \
        consectetur adipiscing elit. Quam mi tortor cursus \
        tincidunt purus tortor cursus tincidunt purus.`,
        src: accessible_svg
    }];

    const navigate = useNavigate();

    const [selectedContentIndex, setSelectedContentIndex] = useState(0);
    const [contentLength] = useState(CONTENT_LIST.length);
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [errorMsg, setErrorMsg] = useState(null);

    const handleNavigation = (type, count) => {

        let sci = selectedContentIndex;
        if (type === LOGIN_CONST.LEFT_ARROW) {
            if (sci === 0) setSelectedContentIndex(contentLength - 1);
            else setSelectedContentIndex(sci - 1);
        } else if (type === LOGIN_CONST.RIGHT_ARROW) {
            if (sci === (contentLength - 1)) setSelectedContentIndex(0);
            else setSelectedContentIndex(sci + 1);
        } else if (type === LOGIN_CONST.RADIO_BUTTON) {
            setSelectedContentIndex(count);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            let sci = selectedContentIndex;
            if (sci === contentLength - 1) setSelectedContentIndex(0);
            else setSelectedContentIndex(sci + 1);
        }, 2000);
        return () => clearTimeout(timer);
    }, [selectedContentIndex]);

    const handleSubmit = () => {
        if (isSubmitDisabled) return;

        setErrorMsg(null);

        let data = {
            email: email,
            password: password
        }

        login(data).then((res) => {
            // props.hospitalDataAction(res);
            props.clearStore();
            props.clearAlarms();
            props.userDataAction({ userRole: res.role });
            redirect(navigate, PAGE_CONST.HOME_PAGE);
        }).catch((err) => {
            setErrorMsg("Error Occurred !!!");
            console.log(err);
        })
    }

    const handleChange = (type, event) => {

        let value = (event.target && event.target.value) || '';
        setIsSubmitDisabled(true);
        setErrorMsg(null);
        switch (type) {

            case LOGIN_CONST.EMAIL:
                setEmail(value);
                if (value && password) setIsSubmitDisabled(false);
                break;
            case LOGIN_CONST.PASSWORD:
                setPassword(value);
                if (email && value) setIsSubmitDisabled(false);
                break;
            default:
                break;
        }
    }

    return (
        <div className='login-container'>
            <div className='left-panel'>
                <div className='logo-container'>
                    <img className='login-logo' src={logo_white_svg} alt="logo" />
                    NOCCARC
                </div>
                <div className='content-container'>
                    <div className='logo-container'>
                        <img className='login-logo' src={logo_svg} alt="logo" />
                    </div>
                    <div className='sign-in-text-container'>
                        Sign In
                    </div>
                    <div className='login-form-container'>
                        <div className='email-container'>
                            <label className='login-label'>Email Id</label>
                            <input
                                className='login-input email'
                                type='email'
                                onChange={(event) => handleChange(LOGIN_CONST.EMAIL, event)} />
                        </div>
                        <div className='password-container'>
                            <label className='login-label'>Password</label>
                            <input
                                className='login-input password'
                                type="password"
                                onChange={(event) => handleChange(LOGIN_CONST.PASSWORD, event)}
                            />
                        </div>
                        <div className='error-msg'>
                            {errorMsg}
                        </div>
                        <div className='sign-in-botton-container'>
                            <button
                                className={isSubmitDisabled ?
                                    'sign-in sign-in-botton disabled' : 'sign-in sign-in-botton'}
                                onClick={() => handleSubmit()}
                            >
                                Sign In</button>
                        </div>
                    </div>
                </div>
                <div className='footer-container'>
                    <img className="login-logo-vector" src={logo_vector} alt="logo-vector" />
                </div>
            </div>
            <div className='right-panel'>
                <div className='content-container'>
                    <div className='illustration-container'>
                        <img
                            className='illustration'
                            src={CONTENT_LIST[selectedContentIndex] && CONTENT_LIST[selectedContentIndex].src} />
                    </div>
                    <div className='below-illustration-container'>
                        <div className='logo-container'>
                            <img className='login-logo' src={logo_svg} alt="logo" />
                        </div>
                        <div className='content'>
                            <div className='heading'>
                                {CONTENT_LIST[selectedContentIndex] && CONTENT_LIST[selectedContentIndex].heading}
                            </div>
                            {/* <div className='body'>
                                {CONTENT_LIST[selectedContentIndex] && CONTENT_LIST[selectedContentIndex].body}
                            </div> */}
                        </div>
                        <div className='content-navigation-container'>
                            <img
                                src={left_arrow_empty}
                                alt="left arrow icon"
                                className="left-arrow-empty arrow"
                                onClick={() => handleNavigation(LOGIN_CONST.LEFT_ARROW)} />
                            <div className='radio-button-container'>
                                {CONTENT_LIST.map((content, count) => {
                                    return (
                                        <input
                                            key={count}
                                            type="radio"
                                            name="navigation"
                                            className={selectedContentIndex === count ?
                                                "navigate-input checked" : "navigate-input"}
                                            onChange={() => handleNavigation(LOGIN_CONST.RADIO_BUTTON, count)}
                                            checked={selectedContentIndex === count ? true : false}
                                        />);
                                })}
                            </div>
                            <img
                                src={right_arrow_empty}
                                alt="righht arrow icon"
                                className="right-arrow-empty arrow"
                                onClick={() => handleNavigation(LOGIN_CONST.RIGHT_ARROW)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {

    return {
        userRole: state.userDataReducer.userRole,
    };
}

const mapDispatchToProps = (dispatch) => {

    return {
        hospitalDataAction: (payload) => dispatch(hospitalDataAction(payload)),
        clearAlarms: (payload) => dispatch(clearAlarms(payload)),
        clearStore: (payload) => dispatch(clearStore(payload)),
        userDataAction: (payload) => dispatch(userDataAction(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);